






























import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import EverythingList from '../../core/components/everything-list/index.vue'
import BulkSendModal from '../../email-templates/components/BulkSendModal.vue'
import TrackingNumberModal from '../../payments/components/TrackingNumberModal.vue'
import { displayDateTime } from '../../core/utils'

@Component({
  components: {
    EverythingList,
    BulkSendModal,
    TrackingNumberModal
  }
})
export default class EmployersEverythingListPage extends Vue {
  breadcrumbs = [{ text: 'Employers'}]

  loading = true

  selectedItem: any = null

  availableColumns = [
    { text: 'ID', value: 'employerId', type: 'number' },
    { text: 'Business Name', value: 'businessName', type: 'string' },
    { text: 'Institution Level', value: 'institutionLevel', display: this.capitalize, type: 'enum', options: [{ text: 'Kindergarten', value: 'kindergarten' }, { text: 'Primary School', value: 'primary-school' }, { text: 'Middle School', value: 'middle-school' }, { text: 'High School', value: 'high-school' }, { text: 'Tertiary', value: 'tertiary' }, { text: 'Language Centre', value: 'language-centre' }, { text: 'Online', value: 'online' }, { text: 'Agent Recruiter', value: 'agent-recruiter' }] },
    { text: 'Given Name', value: 'givenName', type: 'string' },
    { text: 'Surname', value: 'surname', type: 'string' },
    { text: 'Email', value: 'email', type: 'string' },
    { text: 'Phone', value: 'phone', type: 'string' },
    { text: 'Address Line One', value: 'postalAddress1', type: 'string' },
    { text: 'Address Line Two', value: 'postalAddress2', type: 'string' },
    { text: 'City', value: 'postalCity', type: 'string' },
    { text: 'State', value: 'postalState', type: 'string' },
    { text: 'Postcode', value: 'postalPostcode', type: 'string' },
    { text: 'Country', value: 'postalCountry', type: 'string' },
    { text: 'Status', value: 'status', display: (data: string) => data === 'active' ? 'Active' : 'Disabled', type: 'enum', options: [{ text: 'Active', value: 'active' }, { text: 'Disabled', value: 'disabled' }] },
    { text: 'Last Login Time', value: 'lastLoginTime', display: this.displayDate, type: 'date' },
    { text: 'Verified?', value: 'verified', display: this.displayBoolean, type: 'boolean' },
    { text: 'Verified At', value: 'verifiedAt', display: this.displayDate, type: 'date' },
    { text: 'Facebook', value: 'facebook', type: 'string' },
    { text: 'LinkedIn', value: 'linkedin', type: 'string' },
    { text: 'Last Posting', value: 'lastJobPosting', display: this.displayDate, type: 'date' },
    { text: 'Job Posts', value: 'jobPostingCount', type: 'number' }
  ]

  defaultColumns = [
    'employerId', 'businessName', 'institutionLevel', 'givenName', 'surname', 'email', 'phone', 'postalAddress1', 'postalAddress2', 'postalCity', 'postalState',
    'postalPostcode', 'postalCountry', 'status', 'lastLoginTime', 'verified', 'verifiedAt', 'facebook', 'linkedin', 'lastJobPosting', 'jobPostingCount'
  ]

  actions = [
    { text: 'View', method: this.renderItem },
    { text: 'Disable', method: this.disableItem, visible: (item: any) => item.status === 'active' },
    { text: 'Enable', method: this.enableItem, visible: (item: any) => item.status === 'disabled' }
  ]

  bulkActions = []

  public displayDate(data: Date) {
    return data ? this.formatDate(data) : '-'
  }

  public displayBoolean(data: boolean) {
    return data ? 'Yes' : 'No'
  }

  public capitalize(text: string) {
    return text.split('-').map(word => `${word[0].toLocaleUpperCase()}${word.substr(1)}`).join(' ')
  }

  public renderItem(item: any) {
    this.$router.push(`/admin/employers/${item.employerId}`)
  }

  public disableItem(item: any) {
    axios.post(`employers/${item.employerId}/disable`).then((response) => {
      (this.$refs.list as any).updateResults()
      this.$store.dispatch('showSuccess', 'Employer disabled!')
    })
  }

  public enableItem(item: any) {
    axios.post(`employers/${item.employerId}/enable`).then((response) => {
      (this.$refs.list as any).updateResults()
      this.$store.dispatch('showSuccess', 'Employer enabled!')
    })
  }

  public formatDate(date: string | Date) {
    return displayDateTime(date)
  }

  async mounted() {
    this.loading = false
  }
}
